import { ColumnDef, flexRenderComponent } from '@tanstack/angular-table';
import { WheelHistory } from '../interfaces/wheel-history.interface';
import { FairnessButtonComponent } from '@core/components/fairness-button/fairness-button.component';
import { TableColorCellComponent } from '@core/components/table/table-color-cell/table-color-cell.component';
import { TableDateCellComponent } from '@core/components/table/table-date-cell/table-date-cell.component';
import { CostComponent } from '@core/components/cost/cost.component';
import { ModalService } from '@core/modals/services/modal.service';

interface Props {
  modalService: ModalService;
}

export const wheelHistoryTableConfig = ({
  modalService,
}: Props): ColumnDef<WheelHistory>[] => [
  {
    accessorFn: (row) => row.gameid,
    id: 'gameid',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Game ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.amount,
    id: 'amount',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Bet Amount',
      };
    },
    cell: (cell) => {
      return flexRenderComponent(CostComponent, {
        inputs: {
          cost: cell.getValue() as number,
          balanceType: 'skins',
          gap: 4,
          color: 'var(--yellow)',
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.color,
    id: 'color',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Color',
      };
    },
    cell: (cell) => {
      const color = cell.getValue() as string;
      return flexRenderComponent(TableColorCellComponent, {
        inputs: {
          value: color,
          color: `var(--${color})`,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.roll,
    id: 'roll',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Outcome',
      };
    },
    cell: (cell) => {
      const color = cell.getValue() as string;
      return flexRenderComponent(TableColorCellComponent, {
        inputs: {
          value: color,
          color: `var(--${color})`,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.date,
    id: 'date',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Time',
      };
    },
    cell: (cell) => {
      return flexRenderComponent(TableDateCellComponent, {
        inputs: {
          value: cell.getValue() as number,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.outcome,
    id: 'profit',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Profit',
      };
    },
    cell: (cell) => {
      const profit = cell.cell.getValue() as number;
      const isPositive = profit > 0;

      return flexRenderComponent(CostComponent, {
        inputs: {
          cost: profit,
          balanceType: 'skins',
          gap: 4,
          color: isPositive ? 'var(--green)' : 'var(--red)',
        },
      });
    },
    enableSorting: true,
  },
  {
    id: 'fairness',
    header: () => 'Fairness',
    cell: (cell) =>
      flexRenderComponent(FairnessButtonComponent, {
        inputs: {
          href: `/provably-fair/wheel/${cell.row.original.gameid}`,
        },
        outputs: {
          handleClick: () => {
            modalService.close();
          },
        },
      }),
    enableSorting: false,
  },
];
